import { digger } from '@cbre/digger';
import { isMasked, simpleValueValidation } from '@miq/utils';
import { ReportRecord } from '../../../../models/report.model';

// TODO(edmundo): move to utils library
export const UOM_DISTANCE_MAP = {
  meter: 'm',
  kilometer: 'km',
  feet: 'ft',
  mile: 'mi',
};

export function distanceUomAbbrev(val: string) {
  if (isMasked(val) || !simpleValueValidation(val)) {
    return val;
  }

  const lowerCaseUOM = val.toLowerCase();
  const abbrev = UOM_DISTANCE_MAP[lowerCaseUOM];
  return abbrev ? abbrev : val;
}

function getTransportDetailsList(record: ReportRecord) {
  const AMENITIES_TRANSPORT_TYPE = 'Transportation';
  const transportAmenities = digger(record, 'data.property_amenity') || [];

  const mappedTransportAmenities: string[] = [];
  for (const amenity of transportAmenities) {
    const { amenity_type_desc, amenity_distance_from_property, amenity_distance_from_property_uom, amenity_desc } =
      amenity;
    if (amenity_type_desc === AMENITIES_TRANSPORT_TYPE) {
      const uomAbbrev = distanceUomAbbrev(amenity_distance_from_property_uom);
      const distance = amenity_distance_from_property != null ? amenity_distance_from_property : '';
      const uom = uomAbbrev || '';

      if (simpleValueValidation(amenity_desc)) {
        const mappedAmenity = `${distance}${uom} ${amenity_desc}`;
        mappedTransportAmenities.push(mappedAmenity);
      }
    }
  }
  // show max of 4 items
  const max = mappedTransportAmenities.length < 4 ? mappedTransportAmenities.length : 4;
  return mappedTransportAmenities.slice(0, max);
}

export const emeaTransportListDisplayFunctions = {
  529: {
    // 529 - Location Transport List (Poland & Finland)
    displayFn: getTransportDetailsList,
  },
  531: {
    // 531 - Location Transport List (Italy)
    displayFn: getTransportDetailsList,
  },
  533: {
    // 533 - Location Transport List (Norway)
    displayFn: getTransportDetailsList,
  },
  534: {
    // 534 - Location Transport List (Norway)
    displayFn: getTransportDetailsList,
  },
  535: {
    // 535 - Location Transport List (Sweden)
    displayFn: getTransportDetailsList,
  },
};
